import { render, staticRenderFns } from "./DelAccount.vue?vue&type=template&id=0f2b9524&scoped=true&"
import script from "./DelAccount.vue?vue&type=script&lang=js&"
export * from "./DelAccount.vue?vue&type=script&lang=js&"
import style0 from "./DelAccount.vue?vue&type=style&index=0&id=0f2b9524&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2b9524",
  null
  
)

export default component.exports